import { LogoSvgImage } from './images'
import React from 'react'

export const Logo: React.FC = () => {
  return <LogoSvgImage />
}
